import { render, staticRenderFns } from "./Bienvenue.vue?vue&type=template&id=1072b886&"
import script from "./Bienvenue.vue?vue&type=script&lang=js&"
export * from "./Bienvenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports